import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable, BehaviorSubject } from 'rxjs';
import { BaseLoyaltyService } from '../base-loyalty.service';

@Injectable({
    providedIn: 'root'
})

export class CommonService {
    loyaltyUser: any;
    date: any;
    isExpiredByViettel = new BehaviorSubject(false);

    changeExpiredViettel(status) {
        this.isExpiredByViettel.next(status);
    }
    constructor() {
        this.loyaltyUser = JSON.parse(localStorage.getItem('loyaltyUser'));
    }

    isCheckAccountByViettel() {
        if (this.loyaltyUser) {
            // .toLowerCase()
            return this.loyaltyUser.special_partner_code === 'VIETTEL';
        }
        return false;
    }

    isExpiredViettel(date?: any) {
        return moment(date ? date : '').isAfter(moment(this.loyaltyUser.expired_at));
    }
}
